import * as React from 'react';
import type { TextStyle } from 'react-native';

import { Text } from '@sixam/ui/text';
import { cn } from '@sixam/ui/utils';

type BrandLabelProps = React.ComponentProps<typeof Text> &
  Readonly<{
    children: React.ReactNode;
  }>;

const labelStyle: TextStyle = { letterSpacing: 2.4 };

function BrandLabel({ children, className, style, ...props }: BrandLabelProps) {
  return (
    <Text
      className={cn(
        'font-sans text-xs font-semibold uppercase leading-none text-white/70',
        className
      )}
      style={[labelStyle, style]}
      {...props}
    >
      {children}
    </Text>
  );
}

export { BrandLabel };
